const mainClass = "help-character-counter";

const CharacterCounter = ({
	text,
	maxCharacterLength,
	characterCounterLabel = "",
}) => {
	return (
		<span
			className={`${mainClass}`}
		>{`${characterCounterLabel} ${text.length}/${maxCharacterLength}`}</span>
	);
};

export default CharacterCounter;
